import styled from "styled-components";
import { Box as MuiBox, Typography } from "@mui/material";

export const Wrap = styled(MuiBox)`
  &.MuiBox-root {
    width: 100%;
    max-width: calc(2420px - 256px - 96px);
  }
  outline: none;
`;

export const Container = styled(MuiBox)`
  &.MuiBox-root {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const Box = styled(MuiBox)`
  &.MuiBox-root {
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
  }
  & .MuiButtonBase-root {
    color: #79747e;
  }
  & .MuiFormControl-root.MuiTextField-root {
    width: 200px;
    font-size: 14px;
  }
`;

export const DetailContainer = styled(Box)`
  &.MuiBox-root {
    // width: 300px;
    margin: 20px 0;
    padding: 7px 7px;
    display: flex;
    gap: 16px;
  }
`;

export const DetailBox = styled(Box)`
  &.MuiBox-root {
    display: flex;
    flex-direction: column;
    text-overflow: ellipsis;
    align-items: flex-start;
    gap: 0px;
  }
`;

export const DetailTitle = styled(Typography)`
  &.MuiTypography-root {
    width: 100px;
    font-weight: 700;
    font-size: 12px;
  }
`;

export const DetailContents = styled(Typography)`
  &.MuiTypography-root {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    font-size: 12px;
    text-overflow: ellipsis;
  }
`;

export const NoneWrap = styled(Box)`
  &.MuiBox-root {
    padding: 7px 7px;
    display: flex;
    gap: 16px;
  }
`;
